/**
 * @file Renders a modal to confirm certain profile actions. The current
 * profile actions that use this modal are:
 *   * Block
 *   * Hide
 *   * Unmatch
 */

import React, { Component } from "react";

import Modal from "shared/components/Modal";
import UnmatchIcon from "shared/components/svgs/unmatch.svg";

import {
	OKEVENT,
	triggerOkEvent,
} from "shared/util/OkEventHelpers";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";

import "./ConfirmationModal.scss";

// A simple pub sub system to pass state to this component.
const subs = [];
const subscribe = (done) => subs.push(done);

const MODAL_TYPES = {
	block: "block",
	unmatch: "unmatch",
};

class ConfirmationModal extends Component {
	state = {
		onAction: () => false,
		onShow: () => false,
		show: false,
		type: undefined,
	};

	componentDidMount() {
		subscribe((state) => this.setState(state));
	}

	componentDidUpdate(prevProps, prevState) {
		const { show, onShow } = this.state;

		if (!prevState.show && show && onShow) {
			onShow();
		}
	}

	_close = () => {
		this.setState({ show: false });

		if (this.state.type === "hide") {
			triggerOkEvent(OKEVENT.CancelHide);
		} else if (this.state.type === "block") {
			triggerOkEvent(OKEVENT.CancelBlock);
		} else if (this.state.type === "unmatch") {
			triggerOkEvent(OKEVENT.CancelUnmatch);
		} else if (this.state.type === "ocs_pass") {
			triggerOkEvent(OKEVENT.PassCanceled);
		} else if (this.state.type === "ocs_like") {
			triggerOkEvent(OKEVENT.VoteCanceled);
		}
	};

	_closeAndTakeAction = () => {
		this._close();
		this.state.onAction();
	};

	_renderUnmatchChildren = () => {
		return (
			<>
				<UnmatchIcon className="confirmationModal-illustration" />

				<h2 className="confirmationModal-title">
					{_strf("Unmatch?")}
				</h2>

				<p className="confirmationModal-body">
					{_strf("You won’t be able to see or message one another.")}
				</p>

				<button
					onClick={this._closeAndTakeAction}
					className="confirmationModal-action flatbutton blue-new"
				>
					{_str("Unmatch")}
				</button>

				<button
					onClick={this._close}
					className="confirmationModal-cancel"
				>
					{_str("Cancel")}
				</button>
			</>
		);
	};

	_renderBlockChildren = () => {
		return (
			<>
				<h2 className="confirmationModal-title">
					{_strf("Block?")}
				</h2>

				<p className="confirmationModal-body">
					{_strf(`Is this person bothering you? Blocking hides you from them
						and prevents further messages from being exchanged.`)}
				</p>

				<p className="confirmationModal-body">
					{_strf("If you're being harassed by this person, please report them.")}
				</p>

				<button
					onClick={this._closeAndTakeAction}
					className="confirmationModal-action flatbutton blue-new"
				>
					{_str("Yes, please")}
				</button>

				<button
					onClick={this._close}
					className="confirmationModal-cancel"
				>
					{_str("Cancel")}
				</button>
			</>
		);
	};

	render() {
		const { show, type } = this.state;

		if (!MODAL_TYPES[type]) {
			return null;
		}

		return (
			<Modal
				onCancel={this._close}
				noClose
				show={show}
				className="confirmationModal"
				id="confirmationModal"
				willCloseOnClick
			>
				{type === MODAL_TYPES.block && this._renderBlockChildren()}
				{type === MODAL_TYPES.unmatch && this._renderUnmatchChildren()}
			</Modal>
		);
	}
}

export function dispatch(state) {
	subs.forEach((sub) => sub(state));
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/shared/components/ConfirmationModal.jsx